import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Typography,
  Box,
  TextField,
  Grid,
  Button,
  Autocomplete,
} from "@mui/material";
import { postData } from "src/views/utilities/api";
import { redirectUrl } from "src/config";
import { useSnackBar } from "src/context/SnackBarContext";
import Loader from "src/components/Loader";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useFetchData from "src/views/utilities/useFetchData";

function AddPlan({ onClose, refetch, editData, plansMaster,plans }) {


 useFetchData(
  "staffData",
  "/api/getUsersForAdmin"
);
  
  const { showSnackbar } = useSnackBar();
    const [fromDate, setFromDate] = useState(dayjs());
    const [toDate, setToDate] = useState(dayjs());
    
  
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState({
    plan_name: "",
    days: "",
    qty: "",
    price: "",
    offer_price: "",
    mid: "",
  });


  // useEffect(() => {
  //   setLoading(true);
  //   if (editData?.plan_name) {
  //     try {

  //       setPlan(editData);
  //       setEditMode(true);
  //     } catch (error) {
  //       console.error("Error parsing JSON:", error);
  //     }
  //   }
  //   setLoading(false);
  // }, [editData]);

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setPlan({ ...plan, [name]: value });
  // };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!plan.plan_name) newErrors.plan_name = "Name is required.";
  //   if (!plan.price) newErrors.price = "price is required.";
  //   if (!plan.days) newErrors.days = "days is required.";

  //   // if (!uploaded) newErrors.file = "Image is required.";
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };
  const handlePlanChange = (e, value) => {
    setPlan(value);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    // if (!validateForm()) return;

    setLoading(true); // Start loading

    try {
      const response = await postData(`/api/addUsersPlan`,{...plan,start_date:fromDate,end_date:toDate,uid:editData.uid})
      // {id,plan_name,days,qty,price,offer_price,start_date,end_date,uid}

      if (response.success) {
        showSnackbar("success", response.message);
        refetch();
        onClose();
      } else {
        showSnackbar("error", response.message);
      }
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        window.location.href = redirectUrl;
      }
      showSnackbar("error", "Error saving Plan");
    } finally {
      setLoading(false);
    }
  };
 const handleFromDateChange=(date)=>{
  if (plan.days) {
    setFromDate(date);
    setToDate(date.add(parseInt(plan.days),"day"));
    
  }else{
    showSnackbar("warning","please Choose a Plan")
    
  }
 }
 const handleToDateChange=(date)=>{
  if (plan.days) {
    
    
    setToDate(date);
    setFromDate(date.subtract(parseInt(plan.days),"day"))
  }else{
    showSnackbar("warning","please Choose a Plan")

  }
  
 }
 
  return (
    <Box sx={{ p: 1 }} component="form" onSubmit={handleSave}>
      <Loader start={loading} />
      <Typography variant="h6">
         Assign Plan
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Autocomplete
            disablePortal
            clearIcon
            id="combo-box-demo"
            options={plansMaster || []}
            getOptionLabel={(option) => option.plan_name}
            onChange={handlePlanChange}
            value={plan}
            fullWidth
            size="small"
            renderInput={(params) => <TextField {...params} label="Choose Plan" />}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            disabled
            value={plan.plan_name}
            fullWidth
            size="small"
            placeholder="Type Plan name here..."
            label="Name"
            name="plan_name"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
          disabled
            size="small"
            value={plan.price}
            fullWidth
            placeholder="Type Price here..."
            label="Price"
            name="price"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
          disabled
            size="small"
            value={plan.offer_price}
            fullWidth
            placeholder="Type Offer Price here..."
            label="Offer Price"
            name="offer_price"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
          disabled
            size="small"
            value={plan.days}
            fullWidth
            placeholder="Type Duration here..."
            label="Duration"
            name="days"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
          disabled
            size="small"
            value={plan.qty}
            fullWidth
            placeholder="Type no of items here..."
            label="Items"
            name="qty"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From Date"
            format="DD/MM/YYYY"
            value={fromDate}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
              },
            }}
            onChange={handleFromDateChange}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="To Date"
            format="DD/MM/YYYY"
            value={toDate}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
              },
            }}
            onChange={handleToDateChange}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={6}>
          <Button type="submit" fullWidth variant="contained" color="success">
            Add
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button
            fullWidth
            variant="outlined"
            color="warning"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

AddPlan.propTypes = {
  onClose: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  editData: PropTypes.object,
  plansMaster: PropTypes.any,
  plans:PropTypes.any,
};

export default AddPlan;
